import type { FunctionComponent } from "react"

import { clsx } from "clsx"
import dynamic from "next/dynamic"

import { Paper, PAPER_RADIUS } from "@jobteaser/ui-kit/components/Paper/Paper"

import styles from "./Certification.module.css"

type CertificationProps = {
  className?: string
  isGreatPlaceToWork: boolean
  isChooseMyCompany: boolean
  isGlassDoor: boolean
}

const GreatPlaceToWorkDynamic = dynamic(
  () => import("./GreatPlaceToWork/GreatPlaceToWork").then(mod => mod.GreatPlaceToWork),
  { ssr: false }
)

const ChooseMyCompanyDynamic = dynamic(
  () => import("./ChooseMyCompany/ChooseMyCompany").then(mod => mod.ChooseMyCompany),
  { ssr: false }
)

const GlassdoorDynamic = dynamic(() => import("./Glassdoor/Glassdoor").then(mod => mod.Glassdoor), { ssr: false })

export const Certification: FunctionComponent<CertificationProps> = ({
  className,
  isGreatPlaceToWork,
  isChooseMyCompany,
  isGlassDoor,
}) => (
  <Paper
    className={clsx(className, styles.container)}
    hasBorder
    noShadow
    smallSpacing
    radius={PAPER_RADIUS.DEFAULT}
    data-testid="company_certification_block"
  >
    {isGreatPlaceToWork && <GreatPlaceToWorkDynamic />}
    {isChooseMyCompany && <ChooseMyCompanyDynamic />}
    {isGlassDoor && <GlassdoorDynamic />}
  </Paper>
)
